import categories from '@/components/CreatePerks/categories'
import { DEFAULT_LIMIT } from '@/components/ui/pagination/pagination.constants'
import type { SortOrder } from '@/components/ui/table'

import type { PerkType } from './perk-form-modal.constants'
import type { PerkSortKey } from './perks.sort-keys'

export const PERK_IMAGES_PATH = 'chitown-images/neighbourhood'

export type PerkCategoryKey =
  | 'artsAndEntertainment'
  | 'beautyAndSpa'
  | 'breakfastAndCoffee'
  | 'fitnessStudios'
  | 'gymMemberships'
  | 'hotels'
  | 'nightlife'
  | 'petServices'
  | 'restaurantsAndBars'
  | 'services'
  | 'transportationServices'

// Note: `text` is what the backend stores as the perk's category, `key` selects the translated label
export const PERK_CATEGORIES = categories as ReadonlyArray<{
  id: number
  key: PerkCategoryKey
  text: string
}>

export const PERKS_TABLE_ID = 'place-perks-table'

export interface PerksTableFilters {
  category?: string[]
  limit?: number
  search?: string
  skip?: number
  sortBy?: PerkSortKey
  sortOrder?: SortOrder
  type?: PerkType[]
}

export const perksTableInitialFilters: PerksTableFilters = { limit: DEFAULT_LIMIT, skip: 0 }
